// Detailed information on the oembeds that are supported by Composer can be found on the following page:
// https://arcpublishing.atlassian.net/wiki/spaces/EL/pages/2876899339/Composer+oEmbed+Support

const oEmbedOptions = [
  [
    'https?://((m|www)\\.)?youtube\\.com/watch.*',
    'https://www.youtube.com/oembed',
    'youtube',
  ],
  [
    'https?://((m|www)\\.)?youtube\\.com/playlist.*',
    'https://www.youtube.com/oembed',
    'youtube',
  ],
  ['https?://youtu\\.be/.*', 'https://www.youtube.com/oembed', 'youtube'],
  [
    'https?://((m|www)\\.)?youtube\\.com/shorts/.*',
    'https://www.youtube.com/oembed',
    'youtube',
  ],
  [
    'https?://(.+\\.)?vimeo\\.com/.*',
    'https://vimeo.com/api/oembed.json',
    'vimeo',
  ],
  [
    'https?://(www\\.)?dailymotion\\.com/.*',
    'https://www.dailymotion.com/services/oembed',
    'dailymotion',
  ],
  [
    'https?://dai.ly/.*',
    'https://www.dailymotion.com/services/oembed',
    'dailymotion',
  ],
  [
    'https?://(www\\.)?flickr\\.com/.*',
    'https://www.flickr.com/services/oembed.json/',
    'flickr',
  ],
  [
    'https?://flic\\.kr/.*',
    'https://www.flickr.com/services/oembed/',
    'flickr',
  ],
  [
    'https?://(.+\\.)?smugmug\\.com/.*',
    'https://api.smugmug.com/services/oembed/',
    'smugmug',
  ],
  [
    'https?://(www\\.)?hulu\\.com/watch/.*',
    'http://www.hulu.com/api/oembed.json',
    'hulu',
  ],
  [
    'https?://(www\\.)?scribd\\.com/doc/.*',
    'https://www.scribd.com/services/oembed',
    'scribd',
  ],
  ['https?://wordpress.tv/.*', 'https://wordpress.tv/oembed/', 'wordpress'],
  [
    'https?://(.+\\.)?polldaddy\\.com/.*',
    'https://polldaddy.com/oembed/',
    'polldaddy',
  ],
  ['https?://poll\\.fm/.*', 'https://polldaddy.com/oembed/', 'polldaddy'],
  [
    'https?://(www\\.)?funnyordie\\.com/videos/.*',
    'http://www.funnyordie.com/oembed',
    'funnyordie',
  ],
  [
    'https?://(www\\.)?twitter\\.com/.+',
    'https://publish.twitter.com/oembed',
    'twitter',
  ],
  ['https?://(www\\.)?x\\.com/.+', 'https://publish.x.com/oembed', 'twitter'],
  ['https?://vine.co/v/.*', 'https://vine.co/oembed.json', 'vine'],
  [
    'https?://(www\\.)?soundcloud\\.com/.*',
    'https://soundcloud.com/oembed',
    'soundcloud',
  ],
  [
    'https?://(.+?\\.)?slideshare\\.net/.*',
    'https://www.slideshare.net/api/oembed/2',
    'slideshare',
  ],
  [
    'https?://(open|play)\\.spotify\\.com/.*',
    'https://embed.spotify.com/oembed/',
    'spotify',
  ],
  ['https?://(.+\\.)?imgur\\.com/.*', 'http://api.imgur.com/oembed', 'imgur'],
  [
    'https?://(www\\.)?meetu(\\.ps|p\\.com)/.*',
    'https://api.meetup.com/oembed',
    'meetup',
  ],
  [
    'https?://(www\\.)?issuu\\.com/.+/docs/.+',
    'https://issuu.com/oembed_wp',
    'issuu',
  ],
  [
    'https?://(www\\.)?collegehumor\\.com/video/.*',
    'http://www.collegehumor.com/oembed.json',
    'collegehumor',
  ],
  [
    'https?://(www\\.)?mixcloud\\.com/.*',
    'https://www.mixcloud.com/oembed',
    'mixcloud',
  ],
  [
    'https?://(www\\.|embed\\.)?ted\\.com/talks/.*',
    'https://www.ted.com/services/v1/oembed.json',
    'ted',
  ],
  [
    'https?://(www\\.)?(animoto|video214)\\.com/play/.*',
    'https://animoto.com/oembeds/create',
    'animoto',
  ],
  [
    'https?://(.+\\.|www\\.)tumblr\\.com/(post|.+)/.+(/.+)*',
    'https://www.tumblr.com/oembed/1.0',
    'tumblr',
  ],
  [
    'https?://(www\\.)?kickstarter\\.com/projects/.*',
    'https://www.kickstarter.com/services/oembed',
    'kickstarter',
  ],
  [
    'https?://kck\\.st/.*',
    'https://www.kickstarter.com/services/oembed',
    'kickstarter',
  ],
  ['https?://cloudup\\.com/.*', 'https://cloudup.com/oembed', 'cloudup'],
  [
    'https?://(www\\.)?reverbnation\\.com/.*',
    'https://www.reverbnation.com/oembed',
    'reverbnation',
  ],
  [
    'https?://(www\\.)?reddit\\.com/r/[^/]+/comments/.*',
    'https://www.reddit.com/oembed',
    'reddit',
  ],
  [
    'https?://(www\\.)?speakerdeck\\.com/.*',
    'https://speakerdeck.com/oembed.json',
    'speakerdeck',
  ],
  [
    'https?://(www\\.)?instagr(\\.am|am\\.com)(/(p|tv)/).*',
    'https://graph.facebook.com/v8.0/instagram_oembed',
    'instagram',
  ],
  [
    'https?://www\\.facebook\\.com/.*/posts/.*',
    'https://graph.facebook.com/v8.0/oembed_post',
    'facebook-post',
  ],
  [
    'https?://www\\.facebook\\.com/.*/activity/.*',
    'https://graph.facebook.com/v8.0/oembed_post',
    'facebook-post',
  ],
  [
    'https?://www\\.facebook\\.com/(.*/)?photo(s/|\\.php).*',
    'https://graph.facebook.com/v8.0/oembed_post',
    'facebook-post',
  ],
  [
    'https?://www\\.facebook\\.com/permalink\\.php.*',
    'https://graph.facebook.com/v8.0/oembed_post',
    'facebook-post',
  ],
  [
    'https?://www\\.facebook\\.com/media/.*',
    'https://graph.facebook.com/v8.0/oembed_post',
    'facebook-post',
  ],
  [
    'https?://www\\.facebook\\.com/questions/.*',
    'https://graph.facebook.com/v8.0/oembed_post',
    'facebook-post',
  ],
  [
    'https?://www\\.facebook\\.com/notes/.*',
    'https://graph.facebook.com/v8.0/oembed_post',
    'facebook-post',
  ],
  [
    'https?://www\\.facebook\\.com/.*/videos/.*',
    'https://graph.facebook.com/v8.0/oembed_video',
    'facebook-video',
  ],
  [
    'https?://www\\.facebook\\.com/watch/.*',
    'https://graph.facebook.com/v8.0/oembed_video',
    'facebook-video',
  ],
  [
    'https?://www\\.facebook\\.com/video\\.php.*',
    'https://graph.facebook.com/v8.0/oembed_video',
    'facebook-video',
  ],
  [
    'https?://www\\.facebook\\.com/.*',
    'https://graph.facebook.com/v8.0/oembed_page',
    'facebook-page',
  ],
  [
    'https?://www\\.tiktok\\.com/@.+/video/.*',
    'https://www.tiktok.com/oembed',
    'tiktok',
  ],
]

export default oEmbedOptions
